import React from 'react';
import './NewCars.style.css';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ForumIcon from '@mui/icons-material/Forum';
import BoltIcon from '@mui/icons-material/Bolt';

const FEATURES = [
  { Icon: SearchIcon,      titleKey: 'feature1Title', descKey: 'feature1Desc' },
  { Icon: VerifiedUserIcon, titleKey: 'feature2Title', descKey: 'feature2Desc' },
  { Icon: ForumIcon,       titleKey: 'feature3Title', descKey: 'feature3Desc' },
  { Icon: BoltIcon,        titleKey: 'feature4Title', descKey: 'feature4Desc' },
];

export const NewCars = () => {
  const { t } = useTranslation();

  return (
    <section className="why">
      <div className="why__inner">

        <div className="why__head">
          <span className="why__label">{t('ourAdvantages')}</span>
          <h2 className="why__title">{t('whyChooseUs')}</h2>
          <p className="why__sub">{t('whyChooseUsSub')}</p>
        </div>

        <div className="why__grid">
          {FEATURES.map(({ Icon, titleKey, descKey }, i) => (
            <div key={i} className="why__card">
              <div className="why__icon-wrap">
                <Icon sx={{ fontSize: 28, color: '#5F41E4' }} />
              </div>
              <h3>{t(titleKey)}</h3>
              <p>{t(descKey)}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
